export default __webpack_public_path__ + "static/logo-b29f2d23d026a2cbf2dc27df85b8091f.svg";